<div class="emma-card auto-width">
    <!-- CONTENT CARD -->
    <div class="content-card">
        @if (alarmsLoaded) {
            <app-alarm-list
                [alarms]="alarms"
                [project]="project"
                (rowClick)="onAlarmClick($event)"
                (deleteClick)="onAlarmDelete($event)"
                (duplicateClick)="onAlarmDuplicate($event)"
            >
            </app-alarm-list>
        }
        <!-- Add alarm button -->
        <div class="add-button">
            <button
                mat-fab
                id="add-alarm-button"
                aria-label="add alarm"
                (click)="addAlarm()"
                [@animate]="{ value: '*', params: { delay: '300ms', scale: '.2' } }"
            >
                <mat-icon>add_circle_outline</mat-icon>
            </button>
        </div>
    </div>
    <!-- / CONTENT CARD -->
</div>

<h2>{{ "ALARM.ProjectAlarm" | translate }}</h2>
<div class="emma-card auto-width">
    <!-- CONTENT CARD -->
    <div class="content-card">
        @if (projectAlarmsLoaded) {
            <app-alarm-list
                [alarms]="projectAlarms"
                [project]="project"
                (rowClick)="onProjectAlarmClick($event)"
                (deleteClick)="onProjectAlarmDelete($event)"
                (duplicateClick)="onProjectAlarmDuplicate($event)"
            >
            </app-alarm-list>
        }
    </div>
    <!-- / CONTENT CARD -->
</div>
